// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import JMKInfosoftWebsite from './jmk/JMKInfosoftWebsite';
import Login from './login/login';
import FeedbackLogin from './feddback-services/feedback-login';
import Register from './login/Register';
import UserProfile from './login/profile/user/UserProfile';
import SuperAdmin from './login/profile/superadmin/SuperAdmin';
import QRScanner from './feddback-services/QRScanner';
import Admin from './feddback-services/feedbackAdmin';
// import History from './pages/History';
// Pages
import ViewRequirement from './pages/ViewRequirement/ViewRequirement';
import CreateRequirement from './pages/CreateRequirement/CreateRequirement';
import Communication from './pages/Communication/Communication';
import ViewApplications from './pages/applications/ViewApplications';
import ApplyJob from './pages/applyjob/ApplyJob';
import MyApplications from './pages/applications/MyApplications';

// ===== TICKET SYSTEM COMPONENTS =====
import RaiseTicket from './components/Ticket/RaiseTicket';
import MyTickets from './components/Ticket/MyTickets';
import AdminTickets from './components/Ticket/AdminTickets';
import EmployeeForm from './pages/form/form';
import CandidateList from './pages/CandidateList/CandidateList';
import Dashboard from './pages/Dashboard/Dashboard';
// ============================================
// PROTECTED ROUTE FOR MAIN APPLICATION
// ============================================
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const userRole = localStorage.getItem('userRole') || 'candidate';

  if (!isLoggedIn || isLoggedIn !== 'true') {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    if (userRole === 'admin') {
      return <Navigate to="/admin/view-requirement" replace />;
    } else if (userRole === 'external_admin') {
      return <Navigate to="/external-admin/view-requirement" replace />;
    } else if (userRole === 'super_admin') {
      return <Navigate to="/super-admin" replace />;
    } else {
      return <Navigate to="/user/view-requirement" replace />;
    }
  }

  return children;
};

// ============================================
// PROTECTED ROUTE FOR FEEDBACK SYSTEM
// ============================================
const FeedbackProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  if (!isLoggedIn || isLoggedIn !== 'true') {
    return <Navigate to="/feedback-login" replace />;
  }
  return children;
};

// ============================================
// WRONG URL HANDLER
// ============================================
const NotFoundRedirect = () => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  if (isLoggedIn && isLoggedIn === 'true') {
    const userRole = localStorage.getItem('userRole') || 'candidate';
    if (userRole === 'admin') {
      return <Navigate to="/admin/view-requirement" replace />;
    } else if (userRole === 'external_admin') {
      return <Navigate to="/external-admin/view-requirement" replace />;
    } else if (userRole === 'super_admin') {
      return <Navigate to="/super-admin" replace />;
    } else {
      return <Navigate to="/user/view-requirement" replace />;
    }
  }
  return <Navigate to="/login" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          {/* ========================================== */}
          {/* PUBLIC ROUTES */}
          {/* ========================================== */}
          <Route path="/" element={<JMKInfosoftWebsite />} />
          <Route path="/login" element={<Login />} />
          <Route path="/feedback-login" element={<FeedbackLogin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/qr/:qrId" element={<QRScanner />} />
          {/* <Route path="/history" element={<History />} /> */}
          {/* ========================================== */}
          {/* TICKET SYSTEM ROUTES */}
          {/* ========================================== */}

          {/* Candidate Ticket Routes */}
          <Route path="/user/raise-ticket" element={
            <ProtectedRoute allowedRoles={['candidate']}>
              <RaiseTicket />
            </ProtectedRoute>
          } />
          <Route path="/user/my-tickets" element={
            <ProtectedRoute allowedRoles={['candidate']}>
              <MyTickets />
            </ProtectedRoute>
          } />

          {/* Admin Ticket Routes */}
          <Route path="/admin/tickets" element={
            <ProtectedRoute allowedRoles={['admin', 'external_admin', 'super_admin']}>
              <AdminTickets />
            </ProtectedRoute>
          } />

          {/* Employee Master Form */}
          <Route
            path="/admin/form"
            element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <EmployeeForm />
              </ProtectedRoute>
            }
          />

          {/* Profile Route */}
          <Route path="/user" element={
            <ProtectedRoute allowedRoles={['candidate', 'external_admin', 'admin', 'super_admin']}>
              <UserProfile />
            </ProtectedRoute>
          } />

          {/* Candidate Routes */}
          <Route path="/user/view-requirement" element={
            <ProtectedRoute allowedRoles={['candidate', 'external_admin', 'admin', 'super_admin']}>
              <ViewRequirement />
            </ProtectedRoute>
          } />
          <Route path="/user/apply/:id" element={
            <ProtectedRoute allowedRoles={['candidate']}>
              <ApplyJob />
            </ProtectedRoute>
          } />
          <Route path="/user/communication" element={
            <ProtectedRoute allowedRoles={['candidate', 'external_admin', 'admin', 'super_admin']}>
              <Communication />
            </ProtectedRoute>
          } />
          <Route path="/user/applications" element={
            <ProtectedRoute allowedRoles={['candidate']}>
              <MyApplications />
            </ProtectedRoute>
          } />

          {/* Admin Routes */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/view-requirement" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <ViewRequirement />
            </ProtectedRoute>
          } />
          <Route path="/admin/create-requirement" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <CreateRequirement />
            </ProtectedRoute>
          } />
          <Route path="/admin/communication" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Communication />
            </ProtectedRoute>
          } />
          <Route path="/admin/view-applications" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <ViewApplications />
            </ProtectedRoute>
          } />

          {/* External Admin Routes */}
          <Route path="/external-admin/view-requirement" element={
            <ProtectedRoute allowedRoles={['external_admin']}>
              <ViewRequirement />
            </ProtectedRoute>
          } />
          <Route path="/external-admin/view-applications" element={
            <ProtectedRoute allowedRoles={['external_admin']}>
              <ViewApplications />
            </ProtectedRoute>
          } />
          <Route path="/external-admin/communication" element={
            <ProtectedRoute allowedRoles={['external_admin']}>
              <Communication />
            </ProtectedRoute>
          } />

          {/* Super Admin Routes */}
          <Route path="/super-admin" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <SuperAdmin />
            </ProtectedRoute>
          } />
          <Route
            path="/admin/candidates"
            element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <CandidateList />
              </ProtectedRoute>
            }
          />
          {/* ========================================== */}
          {/* FEEDBACK SYSTEM ROUTES */}
          {/* ========================================== */}
          <Route path="/feedbackadmin" element={
            <FeedbackProtectedRoute>
              <Admin />
            </FeedbackProtectedRoute>
          } />

          {/* ========================================== */}
          {/* 404 - Wrong URL Handler */}
          {/* ========================================== */}
          <Route path="*" element={<NotFoundRedirect />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;